export const TAXI_THEME = {
  background: '#1C1C1C',
  backgroundSoft: '#252525',
  gold: '#C9963C',
  goldLight: '#E8C078',
  goldDark: '#A67B2E',
  text: '#FFFFFF',
  textMuted: '#B8B8B8',
  border: 'rgba(201, 150, 60, 0.35)',
  fontHeading: "'Montserrat', 'Inter', system-ui, sans-serif",
  fontBody: "'Inter', system-ui, sans-serif",
  phone: '+385976068055',
  phoneDisplay: '+385 97 606 8055',
  location: 'Poreč, Istria',
  brandName: 'RADENOVIĆ',
  vehicle: 'Peugeot 308 SW',
  password: 'taxi2026',
};
